<!-- basic template for most components -->
<template>
	<div>
	  <page-heading-info
    title="Jefferson County Recorder's Office"
    phone="(740) 283-8566"
    courthouse="true"
    hours="8:30 - 4:30 (M-F) including lunch"
    floor="1st Floor"
    ></page-heading-info>

		<div style="padding-left: 15px; padding-right: 15px;">
			<div class="row bg-primary-02 mt-3 justify-content-center">

				<!--<div class="col-md-6 mt-3 image-flex">
					<img src="static/departments/recorder/bob_stanko.jpg" class="border-1 text-dark" />
				</div>-->

				<div class="col-md-6 mt-3 mb-3">

					<div class="row justify-content-center">
						<div class="col image-flex max-500">
							<img src="static/departments/recorder/scott.jpg" alt="The County Recorder with a large book open in font of him." class="border-1 text-dark" />
						</div>
					</div>

					<div class="row">
						<div class="col text-center font-size-125">
							<div class="row">
								<div class="col-md-6 mt-4">
									<span class="font-size-125">Scott M. Renforth</span>
									<div class="mt-2">County Recorder</div>
								</div>

								<div class="col-md-6 mt-4">
									<span class="font-size-125">Brenda Moffo</span>
									<div class="mt-2">Chief Deputy Recorder</div>
								</div>	
							</div>
						</div>
					</div>

				</div>

				<!--
				<div class="col-md-6 mt-3 mb-3">
					<div class="row justify-content-center">
						<div class="col image-flex max-500">
							<img src="static/departments/recorder/bob_stanko.jpg" class="border-1 text-dark" />
							<div class="row">
								<div class="col text-center font-size-125 mt-3">
									<span class="font-size-125">Brenda Moffo</span>
									<div class="mt-2">Chief Deputy Recorder</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				-->

			</div>
		</div>

		<div class="row mt-3">
			<div class="col-md-6 bg-jeff-yellow-02" style="background-clip: content-box;">
				<div class="p-3">
					<div class="font-size-125">Announcements</div>
					<hr style="margin: 12px 0 12px 0;" />
					<note-text note-id="32"></note-text>
				</div>
			</div>
			
			<div class="col-md-6 padding-bootstrap bg-grey-02" style="background-clip: content-box;">
				<div class="p-3">
					<div class="font-size-125">Abstract Books</div>
					<hr style="margin: 12px 0 12px 0;" />
					<note-text note-id="50"></note-text>
				</div>
				<div class="p-3">
					<div class="font-size-125">Service Member Grave Records</div>
					<hr style="margin: 12px 0 12px 0;" />
					<note-text note-id="54"></note-text>
				</div>
				<div class="p-3">
					<div class="font-size-125">Fees</div>
					<hr style="margin: 12px 0 12px 0;" />
					<div>For Recording Fees please reference
						<a href="static/departments/recorder/JEFFERSON_COUNTY_FILING_FEE_Chart-LATEST.pdf">this chart</a>.
					</div>
					<div class="mt-3">
						The Recorder's Office accepts <strong>CASH</strong> and <strong>CHECK</strong> as payment for
						services. For copies <strong>CREDIT CARDS</strong> (Visa, Master Card, and Discover) are also
						accepted. American Express is <u>not</u> accepted.
					</div>
				</div>
			</div>

		</div>

		<text-box-title title="Document Information" id="document-info" class="mt-4">
			<div class="col-md-6 mt-3">
				<span class="text-bold">Documents dealing with surface parcels to be filed in the Deed Records can be walked through in person or mailed to the following 3 offices:</span>
				<ol class="mt-3">
					<li>Engineer's Mapping Department for legal description approval.</li>
					<li>Assessor's (Auditor) Office for Transfer purposes.</li>
					<li>Recorder's Office - Recording</li>
				</ol>
			</div>

			<div class="col-md-6 mt-3">
				<span class="text-bold">Mineral Deeds, Easements &amp; Rights of Way can be walked through in person or mailed to the following 2 offices:</span>
				<ol class="mt-3">
					<li>Assessor's (Auditor) Office for Transfer purposes.</li>
					<li>Recorder's Office - Recording</li>
				</ol>
			</div>
		</text-box-title>

		<div class="row mt-5">
			<div class="col-md-6">
				<span class="text-bold text-primary-03">Please Note:</span> No Documents will be recorded after 3:45pm. Any documents presented for record after 
				3:45pm will be accepted, checked in and recorded in order at the beginning of the next business day. We kindly ask for those 
				with large volumes of recordings to present them for record as early as possible.
			</div>
		</div>

		<text-box-title title="Electronic Document Filing" id="office-information" class="mt-4">
			<div class="col-md-6 mt-3">
				<icon-title
          title="Overview"
          icon="credit_card"
          underline="true"
					class="mt-3"
          ></icon-title>

					<p>
						Certain documents can now be submitted to the Jefferson County Recorder's Office electronically instead of the conventional method
						of paper documents. We have the ability to receive your documents electronically (e-filing) through our Submitter Service Provider,
						making the process of document recording faster and more efficient than ever before.
					</p>

				<icon-title
          title="How does it work?"
          icon="help_outling"
					icon-color="primary"
          underline="true"
					class="mt-5"
        ></icon-title>

					An account must be set up with one of our accepted E-Recording Partners in order to submit documents electronically. 
					Below is a list of our approved partner companies. To get started, click a company name below to visit their website and get signed up: 

					<ul class="pl-4 mt-3">
						<li><a href="https://mortgagetech.ice.com/products/simplifile/erecording/erecording-network/ohio/jefferson-county">Simplifile</a></li>	
						<li><a href="https://www.erecording.com/counties/ohio/">CSC</a></li>
						<li><a href="https://dmg.indecomm.net/">Indecomm Global Services</a></li>
						<li><a href="https://www.goepn.com/contact/">eRecording Partners Network (ePN)</a></li>
						<li><a href="https://www.hopdox.com/erecording-for-document-submitters">Hopdox eRecording for Document Submitters</a></li>
					</ul>

					<hr style="border-bottom: 2px solid #cdcecf;" class="mb-3" />

					<p>
						Recording fees and transaction fees are paid through ACH (Automated Clearing House) payments.
					</p>

					<p>
						The transmitted documents are checked by office staff and either recorded or rejected. Once the 
						document is recorded, it is available to the public for viewing. The originator will receive 
						confirmation when the document has been successfully recorded. Recording information will be 
						electronically affixed permanently to the image. You can now print, fax, or e-mail the recorded document.
					</p>

					<p>
						All documents must meet our office and state requirements. Our approved partners retain a copy of our 
						standards and policies for e-recording. If a document cannot be recorded, an immediate rejection notice 
						is sent. The documents will be returned to the originator to be corrected and resubmitted.
					</p>

					<p>
						Documents presented for e-recording to the Jefferson County Recorder’s Office will be processed between 
						the hours of 8:30 a.m. and 3:30 p.m., Monday through Friday, Documents received after 3:30 p.m. will be 
						processed the following business day. Documents transmitted when the office is closed will be processed 
						the next business day.
					</p>
			</div>
			<div class="col-md-6 mt-3 bg-grey-02">
				<p>
					<icon-title
					title="Document Types NOT Accepted for E-filing"
					icon="do_disturb"
					underline="true"
					color="danger"
					icon-color="danger"
					class="mt-4"
					></icon-title>

					<strong>
						We cannot E-file ANY documents that transfer ownership/conveyance that need to be processed through the County 
						Tax Map and Auditor's Real Estate Departments. We are in the process of making this available in the near future.
					</strong>

					<ul class="pl-4 mt-3">
						<li>Plats</li>
						<li>Military Discharges (DD214’s)</li>
					</ul>
				</p>
			</div>
		</text-box-title>

	</div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import IconTitle from '@/components/display-utils/IconTitle.vue'
import NoteText from '@/components/display-utils/NoteText.vue'

export default {
	components: {
		PageHeadingInfo,
		TextBoxTitle,
		IconTitle,
		NoteText
	},
  data () {
    return {}
  },
  props: [],
  mounted: function() {
    //called on launch
  },
  methods: {}
}

</script>

<style>
</style>
